import { isPreRelease } from '../flag';
import { Header as HeaderV1 } from './Header-v1';
import { Header as HeaderV2 } from './Header-v2';

const Header = isPreRelease ? HeaderV2 : HeaderV1;

export { Header };
